import config from "config";
import getVar from "core-module/tiny-functions/getVar";
import { isIosDevice } from "../../deviceInfo";

const redirect = async function () {
  let rc = Number(getVar("rc"));
  rc = isNaN(rc) ? 0 : rc;
  rc++;

  const oldRP = "" + window.location.pathname + "";
  const newRP = oldRP.replace(config.MYACCOUNT.APP_PATH, "");
  const rp = encodeURIComponent("" + newRP + "");

  const hw = getVar("hw");
  const seg = getVar("seg");

  const queryArray = [];
  queryArray.push("r=" + config.AUTH.REDIRECT_PARAM);
  queryArray.push("rc=" + rc);
  queryArray.push("rp=" + rp);

  if (hw !== false) {
    queryArray.push("hw=" + hw);
  }
  if (seg !== false) {
    queryArray.push("seg=" + seg);
  }
  if (rc <= 5) {
    const isIos = await isIosDevice();
    if (isIos) {
      // An expired or missing API session should return to MyAccount's
      // provider chooser. Sending iOS users through the legacy identity
      // site cannot complete a native provider sign-in: that page can only
      // direct the user back to /login, which previously created a loop.
      window.location.replace(
        config.MYACCOUNT.APP_PATH + "/login?" + queryArray.join("&")
      );
    } else {
      window.location.replace(
        config.MYACCOUNT.APP_PATH + "/login?" + queryArray.join("&")
      );
    }
  } else {
    throw new Error("Too many redirects");
  }

  return;
};

export default redirect;
